"use client";

function genEventId() {
  if (typeof crypto !== "undefined" && typeof (crypto as any).randomUUID === "function") {
    return (crypto as any).randomUUID();
  }
  // simple fallback
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

// Infer or import your actual types:
import type { StudioMembershipPlanInterval } from "@prisma/client";
export type StudioMembershipPlan = {
  id: string;
  studioId?: string | null;
  // Optional to align with Prisma shape (which uses `title`)
  name?: string | null;
  slug?: string | null;
  description?: string | null;
  stripeProductId?: string | null;
  isSubscription?: boolean;
};

export type StudioMembershipPlanPrice = {
  id: string;
  planId: string;
  stripePriceId?: string | null;
  amount: number; // minor units (e.g., cents)
  currency: string; // "USD" etc
  // Accept both Prisma enum and simple strings
  interval?: StudioMembershipPlanInterval | "day" | "week" | "month" | "year" | null;
  intervalCount?: number | null;
  trialPeriodDays?: number | null;
  trialEligible?: boolean | null;
};

export type MetaCommercePayload = {
  event_name: "Purchase" | "Subscribe" | string;
  event_id: string; // for dedupe
  value: number; // decimal major units
  currency: string;
  order_id?: string;
  content_type?: "product" | "product_group" | "subscription";
  content_ids?: string[];
  contents?: Array<{ id: string; quantity: number; item_price: number }>;
  num_items?: number;
  predicted_ltv?: number;
  plan_interval?: string | null;
  plan_interval_count?: number | null;
  trial_period_days?: number | null;
};

export function buildMetaPayloadFromPlan(
  plan: { id: string; isSubscription?: boolean | null },
  price: StudioMembershipPlanPrice,
  opts: {
    orderId?: string;
    predictedLtv?: number;
    quantity?: number; // default 1
    eventId?: string; // reuse existing event_id for dedupe
  } = {}
): MetaCommercePayload {
  const qty = opts.quantity ?? 1;
  const valueMajor = (price.amount ?? 0) / 100;

  return {
    event_name: plan.isSubscription ? "Subscribe" : "Purchase",
    event_id: opts.eventId ?? genEventId(),
    value: valueMajor,
    currency: price.currency,
    order_id: opts.orderId,
    content_type: plan.isSubscription ? "subscription" : "product",
    content_ids: [plan.id],
    contents: [
      {
        id: price.stripePriceId ?? plan.id,
        quantity: qty,
        item_price: valueMajor,
      },
    ],
    num_items: qty,
    predicted_ltv: opts.predictedLtv,
    plan_interval: price.interval ?? null,
    plan_interval_count: price.intervalCount ?? null,
    trial_period_days: price.trialPeriodDays ?? null,
  };
}
